import type { FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { PlainTooltip } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const Content = styled.div`
    font-weight: 400;
`;

const IconWrapper = styled.div`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: ${colorsPalettes.blue[400]};
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 6px 0 6px;
`;

const StyledAlertIcon = styled(SWReactIcons)`
    path {
        fill: white;
    }
    display: flex;
    height: 12px;
    width: 12px;
`;
interface IPlainTooltip {
    text?: string;
}

export const MMXAlertWithPlainTooltip: FC<IPlainTooltip> = ({ text }) => {
    const tooltipContent = (
        <FlexColumn>
            <Content>
                {text ? i18nFilter()(text) : i18nFilter()("mmx.mobile.new.algo.subtitle.filters.tooltip.content")}
            </Content>
        </FlexColumn>
    );

    return (
        <PlainTooltip
            maxWidth={302}
            tooltipContent={tooltipContent}
            placement="bottom"
        >
            <IconWrapper>
                <StyledAlertIcon iconName="alerts" />
            </IconWrapper>
        </PlainTooltip>
    );
};
